import { ResourceCardResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface, ResourceCardInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class PostResourceCards extends BaseAdapter<ResourceCardResponse[]> implements AdapterInterface {
  rawResponse: ResourceCardResponse[];

  async adaptResponse(request: { component: string }): Promise<ResourceCardInterface[]> {
    await this.fetchApiResponse('/api/resource-cards', HTTPMethod.Post, request);
    return this.rawResponse.map((card) => ({
      category: card.category,
      title: card.title,
      url: card.url,
    }));
  }
}
